import { useEffect, useRef } from "react";
import NewHead from "./landing/NewHead";
import { Helmet } from "react-helmet";
import NewFooter from "./landing/NewFooter";
import { toastAlert } from "../config/toastAlert";
import { sendcontactpageContacts } from "../config/apiCall";
import { sendUnsubmitUserContacts } from "../config/apiCall";
import httpService from "../config/httpCall";
import useState from "react-usestateref";
import CONTACTIMG from "../image/newLanding/contact-temple.svg";
import CONTACTIMGTWO from "../image/newLanding/contact-img.svg";
import PhoneInput from "react-phone-input-2";
import WHATSAPP from "../image/newLanding/landing-whatsapp.svg";
import MAIL from "../image/newLanding/landing-mail.svg";
import PHONE from "../image/newLanding/landing-phone.svg";
import ARROW from "../image/newLanding/arrow.svg";
import TELEGRAM from "../image/newLanding/landing-telegram.svg";
import LINEONE from "../image/newLanding/contact-line-one.svg";
import LINETWO from "../image/newLanding/contact-line-two.svg";

const NewContactus = () => {
  const [isReach, setIsReach] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [selectedPlatform2, setSelectedPlatform2] = useState("whatsApp");
  const [scrollY, setScrollY] = useState(0);
  const [isFooter, setIsFooter] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [colorChanged, setColorChanged] = useState(false);
  const [activeError, setActiveError] = useState(null);

  const NewFormfooterValue2 = {
    newformfootermediumValue: "",
    newformfootermedium: "whatsApp",
    newformfootermessage: "",
    newformfootermobile: "",
    newformfooteruserName: "",
    newformfootermobilecode: "",
  };

  const [newValue2, setnewValue2] = useState(NewFormfooterValue2);

  const handleReachClick = () => {
    setIsReach((prevReach) => !prevReach);
  };

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "whatsApp",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue, newValueref] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);
  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [newformmessageErr, setnewformmessageErr, newformmessageErrref] =
    useState(false);
  const [newformmobileErr, setnewformmobileErr, newformmobileErrref] =
    useState(false);
  const [newformuserNameErr, setnewformuserNameErr, newformuserNameErrref] =
    useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [validationErr, setvalidationErr, validationErrref] = useState("");
  const [platformInput, setPlatformInput, platformInputref] = useState("");

  const [NewFormNMobileCode, setNewFormNMobileCode] = useState();
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [NewFormcountry, setNewFormcountry] = useState();
  const hasSentData = useRef(false);

  useEffect(() => {
    const sendDataOnce = () => {
      if (!hasSentData.current) {
        sendDataToBackend();
        hasSentData.current = true;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendDataOnce();
      }
    };

    const handleBeforeUnload = (event) => {
      sendDataOnce();
      event.preventDefault();
      event.returnValue = "";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [newValue, selectedPlatform2, platformInput, NewFormMobileValue]);

  const sendDataToBackend = async () => {
    try {
      const {
        newformuserName,
        newformmobilecode,
        newformmobile,
        newformmessage,
      } = newValueref.current;

      const userCountry = newValueref.current.NewFormcountry;
      const mediumDetail = platformInputref.current;
      // console.log("Data sent to backend starting *.*.*");

      if (
        newformuserName ||
        userCountry ||
        newformmobilecode ||
        newformmobile ||
        mediumDetail ||
        newformmessage
      ) {
        // console.log("Data sent to backend starting enters.....");
        const obj = {
          userName: newValueref.current.newformuserName,
          userCountry: newValueref.current.NewFormcountry,
          userCountryCode: newValueref.current.newformmobilecode,
          userMobilrNum: newValueref.current.newformmobile,
          contactMedium: selectedPlatform2,
          mediumDetail: platformInputref.current,
          userMessage: newValueref.current.newformmessage,
        };
        // console.log("Data sent to backend", obj);
        var messageSent = await sendUnsubmitUserContacts(obj);
        // console.log("messageSent---->>", messageSent);
      }
    } catch (error) {
      // console.error("Error sending data:", error);
    }
  };

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    setNewFormNMobileCode(countryObj.dialCode);
    setNewFormcountry(countryObj.name);
    newValueref.current["newformmobilecode"] = countryObj.dialCode;
    newValueref.current["newformmobile"] = value;
    newValueref.current["NewFormcountry"] = countryObj.name;
    setSelectedPlatform2("whatsApp");
    setPlatformInput("");
    validate(newValueref.current);
  };

  const validate = async (formData) => {
    try {
      var error = {};
      const countryCodeLength = formData.newformmobilecode
        ? formData.newformmobilecode.length
        : "";
      const actualMobileLength = countryCodeLength
        ? formData.newformmobile.length - countryCodeLength
        : "";
      // const countryCodeLength = formData.newformmobilecode.length;
      // const actualMobileLength =
      //   formData.newformmobile.length - countryCodeLength;

      if (formData.newformuserName.trim() === "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Must enter the field";
        setvalidationErr(error);
        return;
      } else if (formData.newformuserName.length < 3) {
        setnewformuserNameErr(true);

        error.newformuserName = "Invalid username, Must be 3-50 characters";
        setvalidationErr(error);
        return;
      } else if (formData.newformmobile.trim() === "") {
        setnewformuserNameErr(false);

        setnewformmobileErr(true);
        error.newformmobile = "Must enter the field";
        setvalidationErr(error);
        return;
      } else {
        setnewformuserNameErr(false);
      }
      if (actualMobileLength < 7) {
        setnewformmobileErr(true);
        error.newformmobile =
          "Invalid number, Must be at least 7 digits excluding country code";
        setvalidationErr(error);
        return;
      } else {
        setnewformmobileErr(false);
      }
      if (
        (selectedPlatform2 === "email" && platformInputref.current === "") ||
        platformInputref.current.length == 0
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Must enter the field";
        setvalidationErr(error);
        return;
      } else if (
        selectedPlatform2 === "email" &&
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
          platformInputref.current
        )
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Invalid email format";

        setvalidationErr(error);
        return;
      } else if (
        ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
      ) {
        if (platformInputref.current.trim() === "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Must enter the field";
          setvalidationErr(error);
          return;
        } else if (
          selectedPlatform2 === "whatsApp" &&
          platformInputref.current.length < 7
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
          setvalidationErr(error);
          return;
        } else if (
          selectedPlatform2 === "skype" &&
          platformInputref.current.length < 5
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
          setvalidationErr(error);
          return;
        } else if (platformInputref.current.length < 5) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
          setvalidationErr(error);
          return;
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (formData.newformmessage.trim() === "") {
        setnewformmediumValueErr(false);
        setnewformmessageErr(true);
        error.newformmessage = "Must enter the field";
        setvalidationErr(error);
      } else if (formData.newformmessage.length < 3) {
        setnewformmessageErr(true);
        error.newformmessage = "Message must contain at least 3 characters";
        setvalidationErr(error);
      } else if (formData.newformmessage.length > 250) {
        setnewformmessageErr(true);
        error.newformmessage = "Message can't exceed 250 characters";
        setvalidationErr(error);
      } else {
        setnewformmessageErr(false);
      }

      setvalidationErr(error);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePlatformInputChange = (e) => {
    let value = e.target.value;
    if (e.target.type === "number") {
      if (value !== "" && parseFloat(value) < 0) {
        // value = "0";
        return;
      }
    }
    setPlatformInput(value);
    if (e.target.value.startsWith(" ")) {
      e.preventDefault();
      value.trimStart(); // Remove leading spaces
      // / Prevent setting the value if it starts with a space
    } else {
      if (value && value.length > 0) {
        setnewformmediumErr(false);
        setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
      } else {
        setnewformmediumErr(true);
        setvalidationErr((prev) => ({
          ...prev,
          newformmedium: "Must enter the field",
        }));
      }
      // newValueref.current.newformmessage = "";
      validate(newValueref.current);
      if (
        selectedPlatform2 === "email" &&
        !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
      ) {
        validate(newValueref.current);
      }
    }
  };

  const handleKeyPress = (e, maxLength, type) => {
    // console.log(type, "type ---- e", e.key);
    if (
      e.target.value.length >= maxLength &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key)
    ) {
      e.preventDefault();
      return;
    }

    if (type === "email") {
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
      if (
        !validEmailChars.test(e.key) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "number") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      // Prevent space at the start
      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }

      if (e.key === "e") {
        e.preventDefault();
        return;
      }

      // Allow only digits, plus symbol at the start, spaces in the middle, and control keys
      if (
        !/[0-9 ]/.test(e.key) &&
        !(e.key === "+" && cursorPosition === 0) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "text") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }
      if (
        value.length < maxLength ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        return;
      }

      e.preventDefault();
    }
  };

  const handlePlatformSelect = (e, platform) => {
    e.preventDefault();
    setSelectedPlatform2(platform);
    setPlatformInput("");
  };

  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setnewValue((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        let formData = { ...newValue, ...{ [name]: value } };
        setnewValue(formData);
        await validate(formData);
        if (selectedPlatform2 && !platformInputref.current) {
          setnewformmediumValueErr(true);
        } else {
          setnewformmediumValueErr(false);
        }
        // if (name === "newformmessage") {
        //   if (!value.trim()) {
        //     setnewformmessageErr(true);
        //   } else {
        //     setnewformmessageErr(false);
        //   }
        // }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [buttonLoader, setbuttonLoader] = useState(false);

  const sendServiceContact = async (e) => {
    try {
      e.preventDefault();
      validate(newValueref.current);
      if (
        newValueref.current.newformuserName !== "" &&
        newformuserNameErrref.current === false &&
        newformmessageErrref.current === false &&
        newformmobileErrref.current === false &&
        newformmediumValueErrref.current == false &&
        newformmobilecodeErr === false &&
        newValueref.current.newformmessage != ""
      ) {
        // setbuttonLoader(true);

        newValueref.current.newformmedium = selectedPlatform2;
        newValueref.current.newformmediumValue = platformInputref.current;

        var obj = {
          apiUrl: httpService.sendServiceContactDetails,
          payload: newValueref.current,
        };
        var messageSent = await sendcontactpageContacts(obj);
        setbuttonLoader(false);
        newValueref.current.newformuserName = "";
        newValueref.current.newformmessage = "";
        newValueref.current.newformmobile = "";
        newValueref.current.newformmobilecode = "";
        setNewFormMobileValue("");
        setPlatformInput("");
        setNewFormNMobileCode("");
        setNewFormcountry();
        handleNewFormMobile("", "", "", "");
        if (messageSent.status == true) {
          toastAlert("success", messageSent.Message);
        } else {
          toastAlert("error", messageSent.Message);
        }
      } else {
        console.log("valnknkdnkdsnskn ds", newformuserNameErrref.current);

        validate(newValueref.current);
      }
    } catch (errr) {
      console.log("errr", errr);
    }
  };

  return (
    <>
      <header className="newpage nft_new_page  p-0">
        <NewHead />
      </header>

      <Helmet>
        <title>Contact Us | Beleaf Technologies</title>
        <link
          rel="canonical"
          href="https://beleaftechnologies.com/contact-us"
        />
        <meta name="title" content="Contact Us" />
        <meta
          name="description"
          content=" We have a strong desire to assist organizations worldwide in
                achieving improved results through the provision of
                industry-leading solutions that effectively address their
                business challenges, while also fostering innovation and
                promoting company growth."
        />
      </Helmet>

      <div
        className={`${!isReach ? "landingReachOut" : "landingReachOutLeft"}`}
      >
        <div className="landingReachOut__links">
          <div className="landingReachOut__links--wrapper">
            <a href="https://wa.me/7904323274" target="_blank">
              <img src={WHATSAPP} alt="whatsapp" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="https://telegram.me/BeleafSoftTech" target="_blank">
              <img src={TELEGRAM} alt="telegram" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="mailto:business@beleaftechnologies.com" target="_blank">
              <img src={MAIL} alt="mail" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="tel:+91 80567 86622" target="_blank">
              <img src={PHONE} alt="phone" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="vertical-text" onClick={handleReachClick}>
          {isReach ? (
            <span>
              <img
                src={ARROW}
                alt="arrow"
                className="reachOutArrow"
                loading="lazy"
              />
            </span>
          ) : (
            "Reach Out"
          )}
        </div>
      </div>

      <main className="landingMain">
        {/* hero */}
        <article className="primary__landing__container">
          <article className="hero-section">
            <div className="hero-parent">
              <div className="hero-overlay"></div>
              <div className="overlay-text">
                <div className="text-overlay"></div>
              </div>

              <div className="hero-content contact-us-content">
                {/* get in touch */}
                <article className="primary-contact-container ">
                  <div className="primary__contact-title">
                    <p>Contact us</p>
                    <h1>
                      Ready to unlock{" "}
                      <div className="landing-content-inline ">
                        {" "}
                        <span className="span-contact-title">
                          your business's full potential?{" "}
                        </span>
                      </div>
                    </h1>
                  </div>

                  <div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="landing__contact">
                          <div>
                            <h5 className="landing__contact-title primary-contact-us-title">
                              Contact details
                            </h5>
                            <p className="primary-contact-subContent">
                              We're here to assist you, so don't hesitate to
                              reach out and let's start the conversation on how
                              we can help you succeed!
                            </p>
                          </div>
                          <div className="landing__contact--address">
                            <div className="landing__contact--address-wrap contact-primary-opacity">
                              <img
                                src={CONTACTIMGTWO}
                                alt="temple"
                                loading="lazy"
                              />
                              <div className="landing__contact--address-info">
                                <h6>India - Thane</h6>
                                <p>
                                  12, 4th floor Krishnasthal CHS, Mira Gaon Mira
                                  Road East, Thane, Maharastra, <br /> Postal
                                  Code - 401107, India.
                                </p>
                              </div>
                            </div>

                            <div className="landing__contact--address-wrap  contact-opacity">
                              <img
                                src={CONTACTIMG}
                                alt="temple"
                                loading="lazy"
                              />
                              <div className="landing__contact--address-info">
                                <h6>India - Madurai</h6>
                                <p>
                                  5/24, Bharathiyar 7th street, S.S.Colony
                                  Madurai, Tamil Nadu, <br /> Postal Code - 625
                                  016, India.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="landing__contact--form primary-contact-us-form">
                          <form>
                            <h4 className="landing__contact--form-title contact-us-title">
                              Your Details
                            </h4>

                            <div className="mt-4">
                              <label
                                htmlFor="form-name"
                                className="contact-us-label"
                              >
                                Name
                              </label>{" "}
                              <br />
                              <input
                                type="text"
                                id="form-name"
                                placeholder="Enter your name"
                                className="landing__form-input margin-bottom-land contact-us-input"
                                name="newformuserName"
                                autoComplete="off"
                                value={newformuserName}
                                max="50"
                                maxLength="50"
                                onChange={handleNewFormChange}
                                onBlur={(e) => handleKeyPress(e, 50, "text")}
                              />
                              {newformuserNameErrref.current &&
                              newformuserNameErrref.current === true ? (
                                <div className="text-danger font_error_newch">
                                  {" "}
                                  {
                                    validationErrref.current.newformuserName
                                  }{" "}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="mt-4">
                              <label
                                htmlFor="mobile"
                                className="contact-us-label"
                              >
                                Mobile Number
                              </label>{" "}
                              <br />
                              <PhoneInput
                                country={"us"}
                                value={NewFormMobileValue}
                                inputProps={{
                                  name: "phonenumber",
                                  required: true,
                                }}
                                autoComplete="off"
                                className="form-phone landing__form-input margin-bottom-land contact-us-input contact-us-phone"
                                onChange={(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                ) =>
                                  handleNewFormMobile(
                                    value,
                                    countryObj,
                                    e,
                                    formattedValue
                                  )
                                }
                              />
                              {newformmobileErrref.current &&
                              newformmobileErrref.current === true ? (
                                <div className="text-danger font_error_newch">
                                  {validationErrref.current.newformmobile}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="mt-4">
                              <label
                                htmlFor="form-contact"
                                className="contact-us-label"
                              >
                                Contact Medium
                              </label>{" "}
                              <br />
                              <div className="form-contact-medium contact-us-input">
                                <button
                                  type="button"
                                  className="dropdown-toggle landing__form-dropdown"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  {selectedPlatform2 == "whatsApp" ? (
                                    <i className="fa-brands fa-whatsapp"></i>
                                  ) : selectedPlatform2 == "telegram" ? (
                                    <i className="fa-brands fa-telegram"></i>
                                  ) : selectedPlatform2 == "skype" ? (
                                    <i className="fa-brands fa-skype"></i>
                                  ) : selectedPlatform2 == "email" ? (
                                    <i
                                      className="fa fa-envelope"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </button>
                                <div className="dropdown-menu landing__form-drop-menu">
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) =>
                                      handlePlatformSelect(e, "whatsApp")
                                    }
                                  >
                                    <i className="fa-brands fa-whatsapp"></i>
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) =>
                                      handlePlatformSelect(e, "telegram")
                                    }
                                  >
                                    <i className="fa-brands fa-telegram"></i>
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) =>
                                      handlePlatformSelect(e, "skype")
                                    }
                                  >
                                    <i className="fa-brands fa-skype"></i>
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) =>
                                      handlePlatformSelect(e, "email")
                                    }
                                  >
                                    <i
                                      className="fa fa-envelope"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </div>

                                {selectedPlatform2 && (
                                  <input
                                    type={
                                      selectedPlatform2 === "whatsApp"
                                        ? "number"
                                        : "text"
                                    }
                                    className="landing__contact-medium-input"
                                    placeholder={`Enter your ${selectedPlatform2} ${
                                      selectedPlatform2 == "email"
                                        ? "Address"
                                        : selectedPlatform2 === "whatsApp"
                                        ? "number"
                                        : "number / ID"
                                    }`}
                                    maxLength={
                                      selectedPlatform2 === "email"
                                        ? 250
                                        : selectedPlatform2 === "whatsApp"
                                        ? 15
                                        : 32
                                    }
                                    value={platformInputref.current}
                                    autoComplete="off"
                                    onChange={handlePlatformInputChange}
                                    onKeyDown={(e) =>
                                      handleKeyPress(
                                        e,
                                        selectedPlatform2 === "email"
                                          ? 250
                                          : selectedPlatform2 === "whatsApp"
                                          ? 15
                                          : 32,
                                        selectedPlatform2 === "email"
                                          ? "email"
                                          : selectedPlatform2 === "whatsApp"
                                          ? "number"
                                          : "text"
                                      )
                                    }
                                  />
                                )}
                              </div>
                              {newformmediumValueErrref.current &&
                              newformmediumValueErrref.current === true ? (
                                <span className="text-danger font_error_newch">
                                  {validationErrref.current.newformmediumValue}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="mt-4">
                              <label
                                htmlFor="message"
                                className="contact-us-label"
                              >
                                Tell Us About Your Project
                              </label>
                              <br />
                              <textarea
                                id="message"
                                placeholder="Message"
                                className="landing__form-input landing-textarea landing__form-input margin-bottom-land contact-us-input"
                                rows="5"
                                name="newformmessage"
                                value={newformmessage}
                                max="250"
                                maxLength="250"
                                autoComplete="off"
                                onChange={handleNewFormChange}
                                onBlur={(e) => handleKeyPress(e, 250, "text")}
                              ></textarea>

                              {newformmessageErrref.current == true ? (
                                <div className="text-danger font_error_newch">
                                  {validationErrref.current.newformmessage}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="text-center mt-4">
                              {buttonLoader == true ? (
                                <button
                                  className="primary-landing-main-btn"
                                  disabled
                                >
                                  loading....
                                  <span className="ml-2 right-arr">
                                    <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                                </button>
                              ) : (
                                <div className="d-flex align-items-center justify-content-center">
                                  <button
                                    className="primary-landing-main-btn re-hero-btn nw-ct-btn"
                                    onClick={sendServiceContact}
                                  >
                                    <div className="re-btn-txt">Submit</div>

                                    <span className="ml-2 right-arr">
                                      <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                  </button>
                                </div>
                              )}
                            </div>
                          </form>
                          <div className="contact-bg-lines contact-line-one">
                            <img src={LINEONE} alt="lines" loading="lazy" />
                          </div>
                          <div className="contact-bg-lines contact-line-two">
                            <img src={LINETWO} alt="lines" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </article>
        </article>
      </main>

      <footer className="mt-5">
        <NewFooter />
      </footer>
    </>
  );
};

export default NewContactus;
